import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { FormattedMessage } from 'react-intl';

import { legShape } from 'constants/propTypes';
import SegmentInfo from '../SegmentInfo';
import { SegmentDivider } from './SegmentOrdering.styles';

const SegmentOrdering = ({ leg, addOnLeg, currency, trainMarginDeprecated, direction, isMiceGroup }) => {
  const isAddOnBeforeMainLeg = path(['addOnLeg', 'origin', 'isPseudoStation']);

  const Leg =
    (leg && (
      <SegmentDivider key="leg" data-cy="main-leg">
        <h3>
          <FormattedMessage id={`journeySummary.${direction}`} />
        </h3>

        <SegmentInfo leg={leg} currency={currency} trainMarginDeprecated={trainMarginDeprecated} isMiceGroup={isMiceGroup} />
      </SegmentDivider>
    )) ||
    null;

  const AddOnLeg =
    (addOnLeg && (
      <SegmentDivider key="add-on-leg" data-cy="add-on-leg">
        <h3>
          <FormattedMessage id={`journeySummary.${direction}`} />
        </h3>
        <SegmentInfo data-cy="add-on-leg" leg={addOnLeg} isAddOnLeg currency={currency} isMiceGroup={isMiceGroup} />
      </SegmentDivider>
    )) ||
    null;

  if (isAddOnBeforeMainLeg(leg)) {
    return [AddOnLeg, Leg];
  }

  return [Leg, AddOnLeg];
};

SegmentOrdering.propTypes = {
  leg: legShape,
  addOnLeg: legShape,
  currency: PropTypes.string.isRequired,
  trainMarginDeprecated: PropTypes.number,
  isMiceGroup: PropTypes.bool
};

export default SegmentOrdering;
